import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Registrar Service Worker com lógica de Update on Reload
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        updateViaCache: 'none' // Não usar cache para verificar atualizações do SW
      });
      
      console.log('[App] SW registered:', registration.scope);
      
      // Verificar por atualizações
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        console.log('[App] New SW installing...');
        
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // Novo SW instalado, forçar atualização
            console.log('[App] New SW installed, activating...');
            newWorker.postMessage({ type: 'SKIP_WAITING' });
          }
        });
      });
      
      // Recarregar quando o novo SW assumir
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          console.log('[App] New SW active, reloading...');
          window.location.reload();
        }
      });
      
      // Verificar por atualizações a cada 60 segundos
      setInterval(() => {
        registration.update();
      }, 60000);
      
    } catch (error) {
      console.log('[App] SW registration failed:', error);
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
